import { DEMO } from "src/app/config/brand.config";
import { CommonModule } from "@angular/common";
import {
  Component,
  HostBinding,
  inject,
  Input,
  OnInit,
  signal,
} from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { lastValueFrom } from "rxjs";
import {
  MessageModel,
  UserInfoModel,
  defaultUserInfos,
} from "src/app/_metronic/partials/content/chat-inner/dataExample";
import { CartService } from "src/app/services/api/carts.service";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { CartItemComponent } from "../cart-item/cart-item.component";
import { CartSummaryComponent } from "../cart-summary/cart-summary.component";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { DrawerComponent } from "src/app/_metronic/kt/components";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-cart-inner-drawer",
  templateUrl: "./cart-inner-drawer.component.html",
  styleUrl: "./cart-inner-drawer.component.scss",
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    CartItemComponent,
    CartSummaryComponent,
  ],
})
export class CartInnerDrawerComponent implements OnInit {
  readonly demo = DEMO;

  @Input() isDrawer: boolean = false;
  @HostBinding("class") class = "card-body";
  @HostBinding("id") id = this.isDrawer
    ? "kt_drawer_cart_order_body"
    : "kt_cart_order_body";

  fileUrl = environment.apiFileUrl;
  discountCode = signal<any>(null);

  #toastService = inject(ToastService);

  constructor() {}

  #cartService = inject(CartService);
  #router = inject(Router);
  userCart = this.#cartService.userCart;

  ngOnInit(): void {
    this.userCart = this.#cartService.userCart;
  }

  async createTransaction() {
    let payload = { payment_type_id: 1, code: "" };
    if (this.discountCode()) {
      payload.code = this.discountCode().code;
    }
    try {
      const transaction: any = await lastValueFrom(
        this.#cartService.createTransaction(payload)
      );
      this.userCart.update((_) => null);
      await this.#cartService.getUserCart();
      this.#router.navigate(["purchase-order", transaction.id]);
    } catch (error: any) {
      this.#toastService.toastError("เกิดข้อผิดพลาด: " + error.error.errors);
    }
  }

  async deleteCartItem(id: number) {
    try {
      const transaction: any = await lastValueFrom(
        this.#cartService.removeCartItem(id)
      );
      const updateUserCart = await this.#cartService.getUserCart();
      this.userCart = this.#cartService.userCart;
    } catch (error: any) {
      this.#toastService.toastError("เกิดข้อผิดพลาด: " + error);
    }
  }

  async clearCart() {
    try {
      const transaction: any = await lastValueFrom(
        this.#cartService.clearCart()
      );
      const updateUserCart = await this.#cartService.getUserCart();
      this.userCart = this.#cartService.userCart;
    } catch (error: any) {
      this.#toastService.toastError("เกิดข้อผิดพลาด: " + error);
    }
  }

  discountActive(value: any) {
    this.discountCode.update((_) => value);
  }
}
